type ImpactVideoProps = Readonly<{
	video: string;
	title: string;
	view: string;
}>;

export const ImpactVideo: React.FC<ImpactVideoProps> = ({ video, title, view }) => {
	return (
		<div
			className={view === 'mobile' ? 'md:hidden' : 'hidden md:block'}
			data-testid={`impact-story-video-${view}`}
			data-qa={`impact-story-video-${view}`}
		>
			<div className="aspect-video w-full">
				<iframe
					className="md:rounded-large h-full w-full rounded-none"
					data-testid="impact-story-video"
					src={video}
					title={title}
					aria-label={title}
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				/>
			</div>
		</div>
	);
};
